var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMediaShare = (_ref, ref) => {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.44298 10C6.67792 10 6.86393 9.89278 7.09887 9.69295L10.7602 6.25688C10.9315 6.0863 11 5.90596 11 5.75C11 5.58916 10.9364 5.4137 10.7602 5.23825L7.09887 1.8363C6.83456 1.6121 6.68771 1.5 6.45277 1.5C6.11503 1.5 5.87518 1.76806 5.87518 2.08974V3.80046H5.74792C2.46353 3.80046 1 5.89622 1 9.28354C1 9.74169 1.23495 9.99513 1.50906 9.99513C1.71953 9.99513 1.93979 9.93664 2.10622 9.62959C2.88938 8.17231 3.98581 7.70441 5.74792 7.70441H5.87518V9.43463C5.87518 9.75631 6.11503 10 6.44298 10Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMediaShare);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-media-share.0a3f7eb2615f46a20c04df23f44c94be.svg";